import { Column } from 'src/shared/components/Semantic/all'
import { ColorItem } from '../../ColorItem'

interface ExistingColorsSectionProps {
  productVariantColors: Array<{
    color: string
    product_image: any[]
    id: number
  }>
  onColorItemChange: (id: number, hasChanges: boolean) => void
}

export const ExistingColorsSection = ({
  productVariantColors,
  onColorItemChange,
}: ExistingColorsSectionProps) => {
  if (!productVariantColors || productVariantColors.length === 0) {
    return null
  }

  return (
    <Column className="gap-4">
      <p className="text-sm font-medium text-muted-foreground">
        Existing colors ({productVariantColors.length})
      </p>
      {productVariantColors.map(({ color, product_image, id }) => (
        <ColorItem
          key={id}
          color={color}
          illustration={product_image || []}
          id={id}
          onColorItemChange={onColorItemChange}
        />
      ))}
    </Column>
  )
}
